/* PDP gallery — scroll-snap track, arrows, thumbnail sync, video bubble modal. */
(function () {
  function init(root) {
    var track = root.querySelector('[data-gallery-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    var current = 0;

    function goTo(i) {
      current = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function sync() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = Infinity;
      slides.forEach(function (slide, i) {
        var c = slide.offsetLeft - track.offsetLeft + slide.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < best) {
          best = d;
          current = i;
        }
      });

      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === current);
      });

      // arrows dim at the ends, matching the design's 30% state
      if (prev) prev.classList.toggle('is-disabled', current === 0);
      if (next) next.classList.toggle('is-disabled', current === slides.length - 1);
    }

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        sync();
      });
    });

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });

    sync();

    // zoom lightbox
    var lb = root.querySelector('[data-gallery-lb]');
    // grab this before reparenting — once it's on <body> it's out of root's scope
    var modal = root.querySelector('[data-gallery-modal]');

    // .sh-hero__gallery is position:sticky, which creates a stacking context the
    // overlays can't escape — later sections paint over them. Reparent to <body>.
    [lb, modal].forEach(function (el) {
      if (el && el.parentElement !== document.body) document.body.appendChild(el);
    });

    if (lb) {
      var zoomable = slides.filter(function (s) {
        return s.dataset.full;
      });
      var lbImg = lb.querySelector('[data-lb-img]');
      var lbCurrent = lb.querySelector('[data-lb-current]');
      var lbTotal = lb.querySelector('[data-lb-total]');
      var lbIndex = 0;
      if (lbTotal) lbTotal.textContent = zoomable.length;

      var show = function (i) {
        lbIndex = (i + zoomable.length) % zoomable.length;
        lbImg.src = zoomable[lbIndex].dataset.full;
        lbImg.classList.remove('is-zoomed');
        lbImg.style.transformOrigin = 'center center';
        if (lbCurrent) lbCurrent.textContent = lbIndex + 1;
      };

      var openLb = function (i) {
        show(i);
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      };

      var closeLb = function () {
        lb.hidden = true;
        document.documentElement.style.overflow = '';
      };

      // clicking the current slide opens it
      zoomable.forEach(function (slide, i) {
        slide.style.cursor = 'zoom-in';
        slide.addEventListener('click', function () {
          openLb(i);
        });
      });

      lb.querySelector('[data-lb-close]').addEventListener('click', closeLb);
      lb.querySelector('[data-lb-prev]').addEventListener('click', function () { show(lbIndex - 1); });
      lb.querySelector('[data-lb-next]').addEventListener('click', function () { show(lbIndex + 1); });

      // click the backdrop (not the image) to close
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.hasAttribute('data-lb-stage')) closeLb();
      });

      // click the image to zoom in on that point
      lbImg.addEventListener('click', function (e) {
        var r = lbImg.getBoundingClientRect();
        lbImg.style.transformOrigin =
          ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
        lbImg.classList.toggle('is-zoomed');
      });

      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') show(lbIndex - 1);
        if (e.key === 'ArrowRight') show(lbIndex + 1);
      });
    }

    // video bubble
    var bubble = root.querySelector('[data-gallery-bubble]');
    if (bubble && modal) {
      var video = modal.querySelector('video');

      var open = function () {
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        if (video) video.play().catch(function () {});
      };

      var close = function () {
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if (video) video.pause();
      };

      bubble.addEventListener('click', open);

      var closeBtn = modal.querySelector('[data-gallery-modal-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);

      // click outside the video closes it
      modal.addEventListener('click', function (e) {
        if (e.target === modal) close();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-sh-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sh-gallery]');
    if (root) init(root);
  });
})();
